import { render, staticRenderFns } from "./add_older.vue?vue&type=template&id=85982c64&scoped=true&"
import script from "./add_older.vue?vue&type=script&lang=js&"
export * from "./add_older.vue?vue&type=script&lang=js&"
import style0 from "./add_older.vue?vue&type=style&index=0&id=85982c64&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85982c64",
  null
  
)

export default component.exports